module.exports = __webpack_public_path__ + "img/guruji.6d309f0c.jpg";